document.addEventListener('variant:change', function(event) {

  const variant = event.detail.variant;

  if (!variant) return;

  document.querySelectorAll('[data-campaign-price]').forEach((el) => {

    const rate = Number(el.dataset.discountRate);

    if (!rate) return;


    // Shopify価格は最小単位なので100で割る
    const price = Math.floor(
      (variant.price / 100) * (100 - rate) / 100
    );


    // 数字だけ表示（¥はHTML側で付与）
    const money = new Intl.NumberFormat('ja-JP').format(price);


    const target = el.querySelector('[data-campaign-price-number]');


    if (target) {
      target.textContent = money;
    }

  });

});